<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer" :floating="true">
      <v-row justify="center">
        <v-avatar size="100" class="mt-8 mb-3">
          <img src="./assets/profile.png" alt="takuya" />
        </v-avatar>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title text-center">Takuya Yagishita</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list nav>
          <v-list-item v-for="item in items" :key="item.title" link>
            <v-list-item-content v-scroll-to="`#${item.to}`" :data-cursor-hover="true">
              <v-list-item-title class="text-center">
                {{
                item.title
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-row>
      <template v-slot:append>
        <v-row justify="center">
          <div class="mb-6">
            <v-btn
              icon
              color="white"
              class="mx-1"
              href="https://github.com/TakuyaYagishita0202"
              target="_blank"
              :data-cursor-hover="true"
            >
              <v-icon>fab fa-github</v-icon>
            </v-btn>
            <v-btn
              icon
              color="white"
              href="mailto:yagishita0202@gmail.com"
              :data-cursor-hover="true"
            >
              <v-icon small>fas fa-envelope</v-icon>
            </v-btn>
          </div>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-app-bar app color="transparent" flat dark>
      <v-app-bar-nav-icon color="#C4C4C4" :data-cursor-hover="true" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-content v-resize="onResize">
      <div
        id="top"
        :style="{ height: windowSize.height - 64 + 'px' }"
        style="position:relative"
        class="mx-4"
      >
        <vue-typer
          :text='[
            "HELLO, WORLD!",
            "WHO AM I ?",
            "TAKUYA \nYAGISHITA.",
            "HOW OLD AM I ?",
            "27 YEARS OLD.",
            "WHAT IS \nMY OCCUPATION ?",
            "SOFTWARE \nENGINEER.",
          ]'
          :repeat='Infinity'
          :shuffle='false'
          initial-action='typing'
          :pre-type-delay='70'
          :type-delay='150'
          :pre-erase-delay='2000'
          :erase-delay='250'
          erase-style='select-all'
          :erase-on-complete='false'
          caret-animation='blink'
        ></vue-typer>
        <!-- <span
          class="dob float-right"
          style="fontWeight:bold;position:absolute;bottom:0;right:0"
        >Thank you for visiting.</span> -->
      </div>
      <div id="about" class="mx-4 mx-md-8 my-4">
        <h1>About me</h1>
        <v-row>
          <v-col class="d-flex justify-center" cols="12" md="6">
            <div>
              <v-img src="@/assets/profile.png?lazy" max-width="100vw" width="420px" class="grey darken-4"></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <h2 class="mb-4">はじめに</h2>
            <p>
              初めまして。ポートフォリオサイトにお越しいただきまして誠にありがとうございます。
              現在はデジタルビジネスの運用支援を中心に事業を展開している株式会社メンバーズにて、大手通信事業者様のエンドユーザー向けWebシステムの開発・保守・運用に従事しています。
              <br />
              <br />
            </p>
            <h2 class="mb-4">学習・業務経験のある技術</h2>
            <v-chip
              v-for="(skill, index) in learned"
              :key="index"
              class="ma-1"
              :color="skill.color"
              label
            >
              <v-avatar left>
                <v-icon>{{ skill.icon }}</v-icon>
              </v-avatar>
              {{ skill.name }}
            </v-chip>
            <br />
            <br />
            <h2 class="mb-4">主な保有資格など</h2>
            <ul>
              <li>TOEIC 905点（2018年3月）</li>
              <li>基本情報技術者（2021年4月）</li>
              <li>応用情報技術者（2021年12月）</li>
              <li>情報処理安全確保支援士試験合格（2023年6月）</li>
            </ul>
            <br />
            <br />
            <h2 class="mb-4">記事執筆</h2>
            <ul>
              <li>
                <a href="https://www.membersedge.co.jp/blog/php-xdebug/" target="_blank" rel="noopener noreferrer">Xdebug徹底解説！環境ごとの設定方法から仕組みまでどこよりも詳しく解説します（MEMBERS EDGE 社内ブログ）</a>
                <ul>
                  <li>
                    Google「Xdebug」検索結果 最高順位 <b>1位</b>（公式ドキュメントを除く）
                  </li>
                  <li>
                    社内ブログPV数 <b>1位</b>
                  </li>
                </ul>
              </li>
            </ul>
            <br />
          </v-col>
        </v-row>
      </div>
      <div id="history" class="mx-4 mx-md-8 my-4">
        <h1>History</h1>
        <v-timeline :dense="isMobile">
          <v-timeline-item color="#FB5D63">
            <template v-slot:opposite>
              <span>2014.03</span>
            </template>
            <div>
              <h2 class="title font-weight-bold mb-2">兵庫県立御影高等学校卒業</h2>
              <div>
                高校時代はサッカー部に所属し、チームの仲間と切磋琢磨した毎日でした。また、部活と学業と並行してバンド活動(担当パートはドラム)を行っていました。楽器の習得には基礎的な動作を無限に繰り返す忍耐力が欠かせません。自分が掲げた目標に対して
                <span
                  class="highlight"
                >コツコツと愚直に取り組む癖</span>をこの時に身に付けました。
              </div>
            </div>
          </v-timeline-item>
          <v-timeline-item color="#FB5D63">
            <template v-slot:opposite>
              <span>2014.04</span>
            </template>
            <div>
              <h2 class="title font-weight-bold mb-2">大阪市立大学 文学部（社会学専攻） 入学</h2>
              <div>
                高校卒業後は大阪市立大学（現大阪公立大学）に進学し、学業、サークル活動、アルバイトと充実した日々を過ごしました。また、語学の習得にも力を入れ、2018年3月には
                <span
                  class="highlight"
                >TOEIC905点</span>を獲得しました。結果的に新卒で入社した企業では英語を使う機会はほとんどありませんでしたが、英語の情報に触れる機会が多くなった今となっては一生懸命勉強した甲斐があったと感じています。
              </div>
            </div>
          </v-timeline-item>
          <v-timeline-item color="#FB5D63">
            <template v-slot:opposite>
              <span>2018.04</span>
            </template>
            <div>
              <h2 class="title font-weight-bold mb-2">EC関連企業に就職</h2>
              <div>
                大学卒業後は、ITやマーケティング、サプライチェーンなどビジネスに関わる幅広い知識を得ることができる点に魅力を感じネット通販の運営企業に就職。入社後は楽天市場にて腕時計を販売する店舗のディレクターとして様々な施策を実行し、担当店舗の
                <span
                  class="highlight"
                >過去最高月商</span>を記録。さらに
                <span class="highlight">楽天市場出店5万店舗の売り上げ上位100店舗</span>(上位0.2%)にランクインすることができました。
                <span class="highlight">業務改善</span>にも積極的に取り組み、
                <span class="highlight">
                  Google Apps
                  Scriptを独学して業務を自動化、効率化するツールを複数開発
                </span>しました。一部は
                <span
                  class="blue--text link"
                  v-scroll-to="'#works'"
                  data-cursor-hover
                  style="cursor:none"
                >Works</span>に掲載しておりますので是非ご覧ください。
              </div>
            </div>
          </v-timeline-item>
          <v-timeline-item color="#FB5D63">
            <template v-slot:opposite>
              <span>2020.08</span>
            </template>
            <div>
              <h2 class="title font-weight-bold mb-2">在庫一元管理サービスを提供する自社開発系企業に転職</h2>
              <div>
                プログラミングを独学して業務改善を行い、上司や部下に感謝された経験に強いやりがいを感じ、
                <span
                  class="highlight"
                >より多くの人の役に立つアプリケーションやサービスを開発してみたい</span>という思いが強くなりました。
                人間関係も非常に良い職場で葛藤はありましたが、退職を決意し、2020年の8月に在庫一元管理サービスを提供する自社開発系企業に転職しました。受託開発チームに所属し、主にPHPを用いて業務系Webシステムの開発やネットショップの開発、保守・改修などの仕事に従事しました。
              </div>
            </div>
          </v-timeline-item>
          <v-timeline-item color="#FB5D63">
            <template v-slot:opposite>
              <span>2022.04</span>
            </template>
            <div>
              <h2 class="title font-weight-bold mb-2">株式会社メンバーズへ転職（現職）</h2>
              <div>
                有難いことに、未経験ながらたくさんの開発経験を積ませていただきましたが、基軸となる事業がWindowsアプリケーションで提供される在庫一元管理サービスだったこともあり、Web開発の経験が豊富なメンバーがおらず、ほとんど独学に近い状態で業務を行っていました。技術的成長の観点から徐々に限界を感じるようになり、より<span class="highlight">Web開発の経験が豊富かつ意欲の高いメンバーが多く在籍している組織の中でもう一段階自分を磨いていきたい</span>と感じるようになり、現職の株式会社メンバーズへ転職しました。現在は20名弱のチーム体制で、大手通信事業者様が提供するエンドユーザー向けWebサービスの開発・保守・運用に従事しています。
              </div>
            </div>
          </v-timeline-item>
        </v-timeline>
      </div>
      <div id="skills" class="mx-4 mx-md-8 my-4">
        <h1>Skills</h1>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="5">
            <h3 class="mb-4">Tech</h3>
            <Rating
              v-for="(skill, index) in skills.tech"
              :skill="skill.name"
              :value="skill.value"
              :key="`programming-${index}`"
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="5">
            <h3 class="mb-4">Design</h3>
            <Rating
              v-for="(skill, index) in skills.design"
              :skill="skill.name"
              :value="skill.value"
              :key="`design-${index}`"
            />
            <h3 class="mt-4 mb-4">Others</h3>
            <Rating
              v-for="(skill, index) in skills.others"
              :skill="skill.name"
              :value="skill.value"
              :key="`spreadSheet-${index}`"
            />
          </v-col>
        </v-row>
      </div>
      <div id="works" class="mx-4 mx-md-8 my-4">
        <h1>Works</h1>

        <!-- ボクらのアート -->
        <v-row class="my-12">
          <v-col
            cols="12"
            md="6"
            style="backgroundColor:#4158D0; backgroundImage:linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);"
            class="d-flex justify-center align-center"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-img
                  src="@/assets/bokuranoart.jpeg?lazy"
                  :max-width="isMobile ? '280px' : '400px'"
                  class="transition-swing link my-6 my-md-12"
                  :class="`elevation-${hover ? 24 : 2}`"
                  @click.stop="dialog.bokuranoart = true"
                  :data-cursor-hover="true"
                ></v-img>
              </template>
            </v-hover>
            <v-dialog v-model="dialog.bokuranoart" :max-width="isMobile ? '100%' : '1000'">
              <v-card class="d-flex justify-center">
                <img
                  width="100%"
                  :height="isMobile ? windowSize.width / 1.6 : '600px'"
                  src="./assets/bokuranoart.jpeg?lazy"
                  alt="canda"
                />
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" class="mt-4 mt-md-0">
            <h2 class="display-2 font-weight-bold mb-4 ml-md-n12">
              ボクらのアート
            </h2>
            <p>
              これまでのキャリアで培ってきたネットショップ運用・開発の経験を活かして自分でネットショップを運営してみたいと感じ、副業として起業したネットショップです。主に著作権が切れたアート作品を、最高級のファインアート紙へ印刷及び額装し、アートポスターとして販売を行っています。事業計画から商品の仕入れ、ネットショップのデザイン・開発・運用保守、画像製作、受注発送業務、Google Analyticsを用いたアクセス解析などネットショップ運営に関わる全ての工程を一人で行っています。
              <br />
            </p>
            <v-btn
              text
              color="#4158D0"
              href="https://bokuranoart.com"
              target="_blank"
              :data-cursor-hover="true"
            >
              Open Website
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <!-- LINEBOT MAKER -->
        <v-row class="my-12">
          <v-col
            cols="12"
            md="6"
            style="backgroundColor:#1DCD00;"
            class="d-flex justify-center align-center"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-img
                  src="@/assets/linebotmaker.png?lazy"
                  :max-width="isMobile ? '280px' : '400px'"
                  class="transition-swing link my-6 my-md-12"
                  :class="`elevation-${hover ? 24 : 2}`"
                  @click.stop="dialog.linebotmaker = true"
                  :data-cursor-hover="true"
                ></v-img>
              </template>
            </v-hover>
            <v-dialog v-model="dialog.linebotmaker" :max-width="isMobile ? '100%' : '1000'">
              <v-card class="d-flex justify-center">
                <!-- <video controls width="100%" height="auto"> -->
                <video controls width="100%" height="600px">
                  <source src="./assets/video/linebotmaker.mp4" />
                </video>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" class="mt-4 mt-md-0">
            <h2 class="display-2 font-weight-bold mb-4 ml-md-n12">
              LINEBOT MAKER
              <v-btn
                icon
                href="https://github.com/TakuyaYagishita0202/line-bot-maker"
                color="#1DCD00"
                target="_blank"
                :data-cursor-hover="true"
              >
                <v-icon>fab fa-github</v-icon>
              </v-btn>
            </h2>
            <p>
              LINE公式アカウントにシナリオ型チャットボットの機能などを追加することができるWebサービスのプロトタイプです。
              当時、実務でSPAに触れる機会がなく、久しぶりにVue.jsとLaravelを活用したアプリケーションを作ってみようと思い試作しました。
              公式LINEアカウントでネットショップのお問い合わせ対応を自動化したり、会話型広告を追加したりといった用途を想定しています。<br>
              ※画像をクリックすると、デモ動画をご覧いただけます。
              <br />
              <br />制作期間（製作時期）：約2週間（2021年7月, 2022年1月）
              <br />
              <br />使用した主な技術：Vue.js / Vuetify / Laravel / LINE Messaging API
            </p>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <!-- Quitter -->
        <v-row class="my-12">
          <v-col
            cols="12"
            md="6"
            style="backgroundColor:#FB5D63;"
            class="d-flex justify-center align-center"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-img
                  src="@/assets/quitter.png?lazy"
                  :max-width="isMobile ? '280px' : '400px'"
                  class="transition-swing link my-6 my-md-12"
                  :class="`elevation-${hover ? 24 : 2}`"
                  @click.stop="dialog.quitter = true"
                  :data-cursor-hover="true"
                ></v-img>
              </template>
            </v-hover>
            <v-dialog v-model="dialog.quitter" :max-width="isMobile ? '100%' : '1000'">
              <v-card class="d-flex justify-center">
                <!-- <video controls width="100%" height="auto"> -->
                <video controls width="100%" height="600px">
                  <source src="./assets/video/quitter.mp4" />
                </video>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" class="mt-4 mt-md-0">
            <h2 class="display-2 font-weight-bold mb-4 ml-md-n12">
              Quitter
              <v-btn
                icon
                href="https://github.com/TakuyaYagishita0202/laravel_timetracker"
                color="#FB5D63"
                target="_blank"
                :data-cursor-hover="true"
              >
                <v-icon>fab fa-github</v-icon>
              </v-btn>
            </h2>
            <p>
              QuitterはVue.jsとLaravelで構築されたシンプルなタイムトラッキングアプリケーションです。
              エンジニアへ転職する際に、学習の成果物として作成しました。
              プログラミングやデザイン、語学や資格取得に向けた学習など、
              ユーザーの日々の自己投資時間を見える化することでモチベーションの維持に繋げ、
              習慣化のサポートができればという思いで開発しました。
              詳細につきましてはgithubのREADMEに記載しております。是非ご覧ください。
              <br />
              <br />制作期間：約1ヶ月(2020/4/24~5/25)
              <br />
              <br />使用した主な技術：Vue.js / Vuetify / Laravel
            </p>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <!-- Canda -->
        <v-row class="my-12">
          <v-col
            cols="12"
            md="6"
            style="backgroundColor:#28C4CB;"
            class="d-flex justify-center align-center"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-img
                  src="@/assets/canda.png?lazy"
                  :max-width="isMobile ? '280px' : '400px'"
                  class="transition-swing link my-6 my-md-12"
                  :class="`elevation-${hover ? 24 : 2}`"
                  @click.stop="dialog.canda = true"
                  :data-cursor-hover="true"
                ></v-img>
              </template>
            </v-hover>
            <v-dialog v-model="dialog.canda" :max-width="isMobile ? '100%' : '1000'">
              <v-card class="d-flex justify-center">
                <img
                  width="100%"
                  :height="isMobile ? windowSize.width / 1.6 : '600px'"
                  src="./assets/canda.png?lazy"
                  alt="canda"
                />
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" class="mt-4 mt-md-0">
            <h2 class="display-2 font-weight-bold mb-4 ml-md-n12">Canda</h2>
            <p>
              CandaはGoogle Apps
              Scriptで構築されたリマインダーです。リマインドする相手、日時、内容を入力することで、決められた時間にチャットワークを経由してメッセージ及びタスクを送信することができます。特定の時間帯に実行すべきタスクの抜け漏れ防止を補助するツールとして前職時代に業務時間外で開発しました。社内のお役立ちツールの一つとして現在も活用されています。
              <br />
              <br />制作期間：約1週間
              <br />
              <br />使用した主な技術：
              <br />HTML5 / CSS3 / Google Apps Script /
              Chatwork API
            </p>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <!-- 商品情報自動取得くん -->
        <v-row class="my-12">
          <v-col
            cols="12"
            md="6"
            style="backgroundColor:#FF6E02;"
            class="d-flex justify-center align-center"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-img
                  src="@/assets/item.png?lazy"
                  :max-width="isMobile ? '280px' : '400px'"
                  class="transition-swing link my-6 my-md-12"
                  :class="`elevation-${hover ? 24 : 2}`"
                  @click.stop="dialog.rakuten = true"
                  :data-cursor-hover="true"
                ></v-img>
              </template>
            </v-hover>
            <v-dialog v-model="dialog.rakuten" :max-width="isMobile ? '100%' : '1000'">
              <v-card class="d-flex justify-center">
                <video controls width="100%" height="600px">
                  <source src="./assets/video/rakuten.mp4" />
                </video>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" class="mt-4 mt-md-0">
            <h2 class="display-1 font-weight-bold mb-4 ml-md-n12">商品情報自動取得くん</h2>
            <p>
              以前勤務していたネット通販の企業では、出品する商品情報の収集及び入力作業に非常に多くの時間を割いているという重大な課題がありました。そこで開発したのがこちらのツールです。楽天商品検索APIを活用して商品情報の収集及び入力作業を自動化し、結果的に年間約240時間の業務改善に成功しました。
              <br />
              <br />制作期間：約2週間
              <br />
              <br />使用した主な技術：
              <br />Google Apps Script /
              楽天商品検索API
            </p>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <!-- GOOVER -->
        <v-row class="my-12">
          <v-col
            cols="12"
            md="6"
            style="backgroundColor:#FFD700;"
            class="d-flex justify-center align-center"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-img
                  src="@/assets/goover.png?lazy"
                  :max-width="isMobile ? '100px' : '150px'"
                  class="transition-swing link my-3 my-md-6"
                  :class="`elevation-${hover ? 24 : 2}`"
                  @click.stop="dialog.goover = true"
                  :data-cursor-hover="true"
                ></v-img>
              </template>
            </v-hover>
            <v-dialog v-model="dialog.goover" :max-width="isMobile ? '100%' : '400'">
              <v-card class="d-flex justify-center">
                <video controls width="100%" height="600px">
                  <!-- <video controls :width="isMobile ? '100%' : '50%'"> -->
                  <source src="../src/assets/video/GOOVER.mp4" />
                </video>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" class="mt-4 mt-md-0">
            <h2 class="display-2 font-weight-bold mb-4 ml-md-n12">GOOVER</h2>
            <p>
              GOOVERはGoogle Apps ScriptとLINE Messaging
              APIを用いて開発した教育系チャットボットです。語学の習得や資格試験に向けた暗記を補助するツールとして趣味で開発しました。覚えたい事柄に関する質問と、それに対する答えを入力すれば10分後、1日後、1週間後、1ヶ月後に質問のみを返し、答えは特定のIDを入力することで確認できる仕組みになっています。
              <br />
              <br />制作期間：約1週間
              <br />
              <br />使用した主な技術：
              <br />Google Apps Script / LINE Messaging
              API
            </p>
          </v-col>
        </v-row>
      </div>

      <!-- snackbar -->
      <v-snackbar v-model="snackbar.submit" top color="success">
        送信しました。
        <v-btn text @click="snackbar.submit = false">閉じる</v-btn>
      </v-snackbar>
      <v-snackbar v-model="snackbar.error" top color="error">
        送信に失敗しました。時間を置いて再度お試しください。エラーメッセージ：{{
        errorMessage
        }}
        <v-btn text @click="snackbar.error = false">閉じる</v-btn>
      </v-snackbar>

      <!-- Contact -->
      <v-menu
        v-model="menu"
        transition="slide-x-transition"
        :close-on-content-click="false"
        :nudge-width="300"
        :nudge-right="20"
        offset-x
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <!-- float action button -->
          <v-fab-transition>
            <v-btn
              v-show="scrollY > 50"
              fixed
              dark
              fab
              right
              bottom
              large
              color="#FB5D63"
              v-on="on"
              v-bind="attrs"
              :data-cursor-hover="true"
            >
              <v-icon>fas fa-question-circle</v-icon>
            </v-btn>
          </v-fab-transition>
        </template>

        <v-card :loading="loading">
          <v-card-title>
            <span class="headline font-weight-bold">Contact</span>
          </v-card-title>
          <v-card-subtitle class="pb-0">
            こちらのサイトに関するお問い合わせ、制作者へのご連絡
            <br v-if="!isMobile" />につきましてはメール、またはこちらのフォームをご利用ください。
          </v-card-subtitle>
          <v-card-text class="py-0">
            <v-list two-line>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>fas fa-envelope</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>yagishita0202@gmail.com</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text class="pt-0">
            <v-form ref="form" v-model="form.valid">
              <v-text-field v-model="form.name" label="お名前" :rules="rules.required"></v-text-field>
              <v-text-field v-model="form.email" label="メールアドレス" :rules="rules.email"></v-text-field>
              <v-text-field v-model="form.subject" label="件名" :rules="rules.required"></v-text-field>
              <v-textarea v-model="form.message" label="お問い合わせ内容" rows="4" :rules="rules.required"></v-textarea>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text @click="menu = false">閉じる</v-btn>
            <v-spacer></v-spacer>
            <v-btn icon class="my-0" @click="$refs.form.reset()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn text color="primary" :disabled="!form.valid" @click="submit">送信</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-content>
    <cursor-fx color="white" color-hover="white" />
  </v-app>
</template>

<script>
import Rating from "./components/Rating";
import axios from "axios";
import "@/assets/icomoon/style.css";
import { VueTyper } from 'vue-typer';

export default {
  name: "App",

  components: {
    Rating,
    VueTyper
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    if (window.innerWidth <= 600) {
      this.drawer = false;
    }
  },
  data: () => ({
    dialog: { bokuranoart: false, linebotmaker: false, quitter: false, canda: false, rakuten: false, goover: false },
    errorMessage: "",
    loading: false,
    menu: false,
    scrollY: 0,
    drawer: true,
    windowSize: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    rules: {
      required: [v => !!v || "必ず入力してください"],
      email: [
        v => !!v || "必ず入力してください",
        v => /.+@.+\..+/.test(v) || "正しいメールアドレスを入力してください"
      ]
    },
    snackbar: {
      submit: false,
      error: false
    },
    form: {
      valid: true,
      name: "",
      email: "",
      message: "",
      subject: ""
    },
    items: [
      { title: "About me", to: "about", icon: "mdi-view-dashboard" },
      { title: "History", to: "history", icon: "mdi-image" },
      { title: "Skills", to: "skills", icon: "mdi-help-box" },
      { title: "Works", to: "works", icon: "mdi-help-box" }
    ],
    learned: [
      { name: "HTML5", icon: "fab fa-html5", color: "#F16624" },
      { name: "CSS3", icon: "fab fa-css3-alt", color: "#3C9CD7" },
      { name: "Bootstrap4", icon: "mdi-bootstrap", color: "#6C43A0" },
      { name: "JavaScript", icon: "fab fa-js", color: "#F6D43C" },
      { name: "Google Apps Script", icon: "fab fa-google", color: "#4081ED" },
      { name: "jQuery", icon: "mdi-jquery", color: "#0768AC" },
      { name: "Vue.js", icon: "fab fa-vuejs", color: "#41B882" },
      { name: "Vuetify", icon: "mdi-vuetify", color: "#1868C0" },
      { name: "React", icon: "fab fa-react", color: "#61dcfc" },
      { name: "PHP", icon: "fab fa-php", color: "#777BB3" },
      { name: "Laravel", icon: "mdi-laravel", color: "#FF3528" },
      { name: "Symfony", icon: "mdi-symfony", color: "#363636" },
      { name: "Node.js", icon: "fab fa-node-js", color: "#066F03" },
      { name: "Flutter", icon: "mdi-cellphone", color: "#00C1F2" },
      { name: "Python", icon: "mdi-language-python", color: "#FFE05C" },
      { name: "Go", icon: "mdi-language-go", color: "#08A4CE" },
      { name: "Linux", icon: "fab fa-linux", color: "#363636" },
      { name: "Docker", icon: "mdi-docker", color: "#2E93E1" },
      { name: "AWS", icon: "mdi-aws", color: "#F29100" }
    ],
    skills: {
      tech: [
        { name: "HTML5 / CSS3", value: 3 },
        { name: "JavaScript", value: 4 },
        { name: "Vue.js", value: 3 },
        { name: "Google Apps Script", value: 5 },
        { name: "PHP", value: 5 },
        { name: "Laravel", value: 4 },
        { name: "EC-CUBE", value: 3 },
        { name: "Linux(AWS, Docker)", value: 4 },
        { name: "MySQL", value: 4 },
        { name: "PostgreSQL", value: 4 },
        { name: "Git", value: 4 },
      ],
      design: [
        { name: "Photoshop", value: 5 },
        { name: "Figma", value: 3 }
      ],
      others: [
        { name: "Excel", value: 5 },
        { name: "Google Spread Sheet", value: 4 }
      ]
    }
  }),

  methods: {
    onResize() {
      this.windowSize = {
        width: window.innerWidth,
        height: window.innerHeight
      };
    },
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    submit() {
      this.loading = true;
      if (confirm("この内容で送信しますか？")) {
        const submitParams = new FormData();
        // お名前のname属性値
        submitParams.append("entry.737728292", this.form.name);
        // メールアドレスのname属性値
        submitParams.append("entry.426685796", this.form.email);
        // お問い合わせ内容のname属性値
        submitParams.append("entry.188667845", this.form.message);
        // 件名のname属性値
        submitParams.append("entry.713930743", this.form.subject);

        // CORSエラー対策
        const CORS_PROXY = "https://cors-anywhere.herokuapp.com/";
        // Googleフォームのaction属性値
        const GOOGLE_FORM_ACTION =
          "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfYTz-GGY8EbYEYtIW6HJ1D5bggUjltbzWHfawcWd7rl5YYtQ/formResponse";

        // Ajax POST通信
        axios
          .post(CORS_PROXY + GOOGLE_FORM_ACTION, submitParams)
          .then(() => {
            // フォーム初期化
            this.$refs.form.reset();
            // 送信完了のスナックバー表示
            this.snackbar.submit = true;
            this.loading = false;
            this.menu = false;
          })
          .catch(e => {
            this.errorMessage = e;
            this.snackbar.error = true;
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    }
  },

  computed: {
    isMobile() {
      if (this.windowSize.width <= 600) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style>
/* light theme */
/* .v-content {
  background-color: #f5f5f5;
} */
/* p {
  color: #444444 !important;
} */

#top {
  word-wrap: break-word;
}
#top > .name {
  line-height: 100%;
  font-weight: bold;
  font-size: calc(5.5rem + ((1vw - 6px) * 8.2822));
}
#top .vue-typer {
  font-size: calc(5.5rem + ((1vw - 6px) * 8.2822));
  line-height: 100%;
  font-weight: bold;
}
#top .vue-typer .custom.char {
  color: white;
}
#top .vue-typer .custom.char.selected {
  background-color: #264F78;
}
#top .vue-typer .custom.caret {
  width: calc((5.5rem + ((1vw - 6px) * 8.2822)) / 4);
  background-color: #3F51B5;
}
#top > .dob {
  font-size: calc(2rem + ((1vw - 6px) * 1.8405));
}
.highlight {
  font-weight: bold;
  color: #fb5d63;
}
h1 {
  font-size: 64px;
  font-weight: bold;
  color: #fb5d63;
}
.link:hover {
  cursor: pointer;
}
.cursor-fx,
.cursor-fx--loaded,
.cursor-fx__inner,
.cursor-fx__inner__outside,
.cursor-fx__inner__custom,
.cursor-fx__inner__inside {
  z-index: 1000;
}

@media screen and (max-width: 600px) {
  #top {
    padding-top: 72px;
  }
  #top > .name {
    float: left !important;
  }
}
</style>
